export const ageGroupOptions = [
  { value: '5', label: 'U5' },
  { value: '6', label: 'U6' },
  { value: '7', label: 'U7' },
  { value: '8', label: 'U8' },
  { value: '9', label: 'U9' },
  { value: '10', label: 'U10' },
  { value: '11', label: 'U11' },
  { value: '12', label: 'U12' },
  { value: '13', label: 'U13' },
  { value: '14-17', label: 'U14-17' },
  { value: '18', label: 'U18' },
  { value: '20', label: 'U20' },
  { value: 'Seniors', label: 'Seniors' },
  { value: 'Masters', label: 'Masters' },
];

// Dropdown labels show "Active"/"Inactive" — friendlier than the server's
// underlying "YES"/"NO" enum. Values are unchanged so the form state and
// submit payload still match the server contract; only the display differs.
export const participationStatusOptions = [
  { value: 'YES', label: 'Active' },
  { value: 'NO', label: 'Inactive' },
];
